import React from "react";
import PageHeader from "../components/PageHeader";
import ContactForm from "../components/ContactForm";
import { partners } from "../mock";

const HostEvent = () => {
  return (
    <div>
      <PageHeader title="Current BOT Community Partners" />

      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10">
          {partners.map((p) => (
            <div
              key={p.name}
              className="bg-[#181818] border border-[#2a2a2a] hover:border-[#e8a13a]/60 transition-all duration-500 group"
            >
              <div className="overflow-hidden aspect-video">
                <img
                  src={p.image}
                  alt={p.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
              </div>
              <div className="p-8">
                <h3 className="font-display text-2xl text-[#e8a13a] mb-4">{p.name}</h3>
                <p className="text-[#d5c9a8] leading-relaxed">{p.body}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-20 px-6 bg-[#181818] border-t border-[#2a2a2a]">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-display text-3xl md:text-4xl text-[#e8a13a] mb-3 text-center">
            Are you a Pub, Brewery, Cafe or creative arts event space?
          </h2>
          <p className="text-center text-[#c8bfae] mb-10">Drop us a line here!</p>
          <ContactForm title="" storageKey="bot_host_applications" />
          <p className="text-center mt-10 text-[#c8bfae] font-serif-italic">
            We look forward to working with you! We are looking to host BOT Events across Ontario.
          </p>
        </div>
      </section>
    </div>
  );
};

export default HostEvent;
